class Favorites {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("favorites", () => ({
                    isClose: true,

                    stateFavoriteList: null,
                    globalFavoriteError: false,
                    globalFavoriteLoading: false,
                    favoriteError: {},
                    favoriteLoading: {},

                    favoritesList: {},
                    allDate: null,

                    LOADING: 1,
                    ERROR: 2,

                    NONE: 0,
                    EVENT: 1,
                    DATE: 2,

                    addWording: "Ajouter toutes les dates aux favoris",
                    deleteWording: "Retirer toutes les dates des favoris",

                    favEventId: 0,
                    favDateId: 0,
                    favDates: [],

                    fromCalendar: false,

                    init() {
                        if (window.CONFIG.connected) {
                            this.initFavorites();
                        }
                    },

                    initFavorites() {
                        this.stateFavoriteList = this.LOADING;
                        window.useHttpApi
                            .get("/v1/favorites")
                            .then(({ body }) => {
                                body.forEach((favorite) => {
                                    const { event, date } = favorite;
                                    if (!this.favoritesList[event]) {
                                        this.favoritesList[event] = {};
                                    }
                                    if (date) {
                                        this.favoritesList[event][date] = true;
                                    } else {
                                        this.favoritesList[event] = true;
                                    }
                                });
                                this.stateFavoriteList = null;
                            })
                            .catch(() => {
                                this.stateFavoriteList = this.ERROR;
                            });
                    },

                    isLoading(eventId = null, dateId = null) {
                        if (!eventId && !dateId) {
                            return this.globalFavoriteLoading;
                        }
                        return (
                            this.favoriteLoading[eventId] &&
                            this.favoriteLoading[eventId][dateId]
                        );
                    },

                    isError(eventId = null, dateId = null) {
                        if (!eventId && !dateId) {
                            return this.globalFavoriteError;
                        }
                        return (
                            this.favoriteError[eventId] &&
                            this.favoriteError[eventId][dateId]
                        );
                    },

                    setLoading(value, eventId, dateId) {
                        if (!eventId || !dateId) {
                            this.globalFavoriteLoading = value;
                            return;
                        }
                        if (!this.favoriteLoading[eventId]) {
                            this.favoriteLoading[eventId] = {};
                        }
                        this.favoriteLoading[eventId][dateId] = value;
                    },

                    setError(value, eventId = null, dateId = null) {
                        this.globalFavoriteError = value;
                        if (!eventId || !dateId) {
                            return;
                        }

                        if (!this.favoriteError[eventId]) {
                            this.favoriteError[eventId] = {};
                        }
                        this.favoriteError[eventId][dateId] = value;
                    },

                    resetLoading() {
                        this.globalFavoriteLoading = false;
                        this.favoriteLoading = {};
                    },

                    resetError() {
                        this.globalFavoriteError = false;
                        this.favoriteError = {};
                    },

                    update(
                        eventId,
                        dateId,
                        element = null,
                        dialog = false,
                        isEventPermanent = false,
                    ) {
                        if (element.ariaDisabled === "true") {
                            return;
                        }

                        this.favEventId = eventId;
                        this.favDateId = dateId;

                        const state = this.getFavoriteState(eventId, dateId);
                        this.allDate = state === this.EVENT ? true : null;

                        if (!window.CONFIG.connected) {
                            const dialogFavorites = document.querySelector(
                                `[x-ref='dialogFavorites']`,
                            );
                            if (dialogFavorites && !dialogFavorites.open) {
                                dialogFavorites.showModal();
                            }

                            this.isClose = false;
                            return;
                        }

                        if (state === this.DATE) {
                            this.toggle(eventId, dateId, null, dialog);
                            return;
                        }

                        if (state === this.NONE) {
                            if (this.fromCalendar || !isEventPermanent) {
                                this.toggle(eventId, dateId, null, dialog);
                                return;
                            }
                        }

                        this.resetLoading();
                        this.resetError();

                        const dialogFavorites = document.querySelector(
                            `[x-ref='dialogFavorites']`,
                        );

                        if (dialogFavorites && !dialogFavorites.open) {
                            dialogFavorites.showModal();
                        }

                        this.isClose = false;
                        return;
                    },

                    deleteAll(eventId, el = null) {
                        if (el.ariaDisabled === "true") {
                            return;
                        }

                        if (!window.CONFIG.connected) {
                            const dialogFavorites = document.querySelector(
                                `[x-ref='dialogFavorites']`,
                            );

                            if (dialogFavorites && !dialogFavorites.open) {
                                dialogFavorites.showModal();
                            }

                            this.isClose = false;
                            return;
                        }

                        this.setLoading(true);
                        if (!this.favoritesList[eventId]) {
                            this.favoritesList[eventId] = {};
                        }
                        window.useHttpApi
                            .delete(
                                "/v1/favorite",
                                { event: eventId, date: 0 },
                                { extra: { dialog: true } },
                            )
                            .then(() => {
                                this.favoritesList[eventId] = {};
                                this.setError(false);
                            })
                            .catch(() => {
                                this.setError(true);
                            })
                            .finally(() => {
                                this.setLoading(false);
                            });
                    },

                    addAll(eventId, el) {
                        if (el.ariaDisabled === "true") {
                            return;
                        }

                        if (!window.CONFIG.connected) {
                            const dialogFavorites = document.querySelector(
                                `[x-ref='dialogFavorites']`,
                            )();

                            if (dialogFavorites && !dialogFavorites.open) {
                                dialogFavorites.showModal();
                            }
                            this.isClose = false;
                            return;
                        }

                        this.setLoading(true);
                        if (!this.favoritesList[eventId]) {
                            this.favoritesList[eventId] = {};
                        }
                        window.useHttpApi
                            .put(
                                "/v1/favorite",
                                { event: eventId, date: 0 },
                                { extra: { dialog: true } },
                            )
                            .then(() => {
                                this.favoritesList[eventId] = true;

                                this.setError(false);
                            })
                            .catch(() => {
                                this.setError(true);
                            })
                            .finally(() => {
                                this.setLoading(false);
                            });
                    },

                    toggle(eventId, dateId, element = null, dialog = false) {
                        if (element && element.ariaDisabled === "true") {
                            return;
                        }

                        this.setLoading(true, eventId, dateId);

                        const year = dateId.toString().slice(0, 4);
                        const month = dateId.toString().slice(4, 6);
                        const day = dateId.toString().slice(6, 8);
                        const dt = new Date(year, month - 1, day);

                        const dateTimestamp = Math.round(dt.getTime() / 1000);

                        if (this.getFavoriteState(eventId, dateId)) {
                            window.useHttpApi
                                .delete(
                                    "/v1/favorite",
                                    {
                                        event: eventId,
                                        date:
                                            !this.allDate ||
                                            this.allDate === "false"
                                                ? dateTimestamp
                                                : 0,
                                    },
                                    { extra: { dialog } },
                                )
                                .then(() => {
                                    if (
                                        !this.allDate ||
                                        this.allDate === "false"
                                    ) {
                                        this.favoritesList[eventId][dateId] =
                                            false;
                                    } else {
                                        this.favoritesList[eventId] = false;
                                    }
                                    this.closeDialogFavorite();
                                    this.setError(false, eventId, dateId);
                                })
                                .catch(() => {
                                    this.setError(true, eventId, dateId);
                                    if (!dialog) {
                                        window.useSnackbar.add({
                                            key: window.useSnackbar.ERROR,
                                            type: window.useSnackbar.TYPE_ERROR,
                                            message:
                                                "Nous avons rencontré une erreur. Veuillez réessayer ultérieurement.",
                                            close: true,
                                        });
                                    }
                                })
                                .finally(() => {
                                    this.setLoading(false, eventId, dateId);
                                });
                        } else {
                            window.useHttpApi
                                .put(
                                    "/v1/favorite",
                                    {
                                        event: eventId,
                                        date:
                                            !this.allDate ||
                                            this.allDate === "false"
                                                ? dateTimestamp
                                                : 0,
                                    },
                                    { extra: { dialog } },
                                )
                                .then(() => {
                                    if (
                                        !this.allDate ||
                                        this.allDate === "false"
                                    ) {
                                        if (!this.favoritesList[eventId]) {
                                            this.favoritesList[eventId] = {};
                                        }
                                        this.favoritesList[eventId][dateId] =
                                            true;
                                    } else {
                                        this.favoritesList[eventId] = true;
                                    }
                                    this.closeDialogFavorite();
                                    this.setError(false, eventId, dateId);
                                })
                                .catch(() => {
                                    this.setError(true, eventId, dateId);
                                    if (!dialog) {
                                        window.useSnackbar.add({
                                            key: window.useSnackbar.ERROR,
                                            type: window.useSnackbar.TYPE_ERROR,
                                            message:
                                                "Nous avons rencontré une erreur. Veuillez réessayer ultérieurement.",
                                            close: true,
                                        });
                                    }
                                })
                                .finally(() => {
                                    this.setLoading(false, eventId, dateId);
                                });
                        }
                        this.fromCalendar = false;
                    },

                    getFavoriteState(eventId, dateId) {
                        if (!this.favoritesList[eventId]) {
                            return this.NONE;
                        }

                        if (this.favoritesList[eventId] === true) {
                            return this.EVENT;
                        }

                        if (this.favoritesList[eventId][dateId]) {
                            return this.DATE;
                        }

                        return this.NONE;
                    },

                    closeDialogFavorite(element = null) {
                        if (element?.ariaDisabled === "true") {
                            return;
                        }
                        this.isClose = true;

                        const dialog = document.querySelector(
                            `[x-ref='dialogFavorites']`,
                        );
                        if (dialog?.open) {
                            dialog.close();
                        }
                    },
                }));
            },
            { once: true },
        );
    }
}

new Favorites();
